<template>
  <div>
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">Import Employees</li>
      </ol>
    </div>
    <div class="attendance-report">

      <div class="row">
        <div class="col-xl-12 mb-30">
          <div class="card card-statistics">
            <div class="card-body">
              <div class="form-row">
                <div class="form-group col-3">
                  <form id="importForm" enctype="multipart/form-data">
                    <input type="file" class="form-control" accept=".xlsx" @change="onChange" id="importFile"
                           name="import">
                    <input type="hidden" name="company_id" v-model="company_id">
      </form>
                </div>
                <div class="col-9">
                  <a href="https://admin.cleverstaff.com/adminAssets/uploads/import-staff.xlsx"
                     download="import-staff-641aa54ad34b2.xlsx" class="btn btn-outline-info float-right">
                    <span class="fa fa-file-excel-o"></span>Download Sample Template</a>
                </div>
                <div class="col-6">
                  <h6>Please consider following while populating records in import file.</h6>
                  <ul>
                    <li>All Fields are required otherwise data will not be imported for that user.</li>
                    <li>Phone number must be with country code e.g. <b>+923452356435</b></li>
                    <li><strong>Do not change the order of the sheets/Columns.</strong></li>
                    <li><strong>Data should be entered like sample data added.</strong></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="card card-statistics  h-100 mt-5" v-if="importDataShow" id="staffTableElement">
            <div class="card-header">
              <div class="row">
                <div class="col-6">
                  <h2 class="card-title mb-0 pb-0 border-0">Import Staff   {{fileName}}</h2>
                </div>
                <div class="col-6">
                  <button type="submit" class="btn btn-outline-primary float-right" @click="saveImportStaffData"  id="importStaff">
                    <span class="fa fa-arrow-circle-o-down mr-2"></span>
                    Import
                  </button>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-lg-12 col-md-12">
                  <table class="table">
                    <thead >
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Phone</th>
                      <th>Gender</th>
                      <th>Role</th>
                      <th>Salary</th>
                      <th>Shift</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="employee in excelData">
                      <td>
                        <label>{{ employee.Name }}</label>
                      </td>
                      <td>
                        <label>{{ employee.Email }}</label>
                      </td>
                      <td>
                        <label>{{ employee.Phone }}</label>
                      </td>
                      <td>
                        <label>{{ employee.Gender }}</label>

                      </td>
                      <td>
                        <label>{{employee.Role }}</label>

                      </td>
                      <td>
                        <label>{{ employee.Salary }}</label>

                      </td>
                      <td>
                        <label>{{ employee.Shift }}</label>
                      </td>
                    </tr>
                    </tbody>
                    <tfoot></tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import moment from 'moment';

export default {
  components: {},
  data() {
    return {
      import: '',
      file: '',
      company_id: this.$store.getters.getSelectedCompany.id,
      excelData: [],
      importDataShow:false
    }
  },

  created() {

  },
  mounted() {

  },
  methods: {
    onChange(event) {
      this.importDataShow=true
      var input = event.target;
      this.file = event.target.files[0];

      var reader = new FileReader();
      reader.onload = () => {
        var fileData = reader.result;
        var wb = XLSX.read(fileData, {type : 'binary'});
        this.import=wb;
        var rowObj =XLSX.utils.sheet_to_json(wb.Sheets['Employees']);
        //console.log(rowObj,'rowObj rowObj rowObj');
        this.excelData = rowObj
      };
      reader.readAsBinaryString(input.files[0]);
    },
    saveImportStaffData(){
      var importForm = $('#importForm')[0];
      // Create an FormData object
      var data = new FormData(importForm);
      this.$axios({
        method: "POST",
        data: data,
        url: this.$ImportStaff,
        headers: this.getImageHeader(),
      }).then((res) => {
        if (res.data.status == 200) {
          $root.$toast.success(res.data.message);
          this.$router.push({name: 'employees'});
        }
      });
    },

  }
}
</script>
<style scoped>


</style>
